import { IconPreset, RecFlowEffect, RecFlowExperience, ReviewFlowEffect } from '@/types'
import {
  Category,
  EdibleSubCategory,
  RecFlowScent,
  RecFlowTerpene,
  ReviewFlowExperience,
} from '@/types/widget'

export const DEFAULT_WIDGET_ICON =
  'https://cdn.alpineiq.com/media/1/1718c1d1-6bed-41c0-87a5-cb235c62978e/aiq-chat-widget-default.png'

export type Effect = RecFlowEffect | ReviewFlowEffect

export const DEFAULT_EFFECTS_IMAGES_BY_PRESET: Record<IconPreset, Record<Effect, string>> = {
  Classic: {
    Calm: '',
    Creative: '',
    Focused: '',
    Relaxed: '',
    Energized: '',
    Euphoric: '',
    Stimulated: '',
    Sedated: '',
    Sleepy: '',
    Uplifted: '',
  },
  Smooth: {
    Calm: 'https://cdn.alpineiq.com/media/1/b9372e8a-6f18-4829-9e43-8ff83c34dd7f/Property_1_Calm.png',
    Focused: 'https://cdn.alpineiq.com/media/1/b96480fe-3781-4f68-b9f9-c7f7c4aeda56/Property_1_Focused.png',
    Euphoric: 'https://cdn.alpineiq.com/media/1/744a460c-7502-46a1-a11f-5e43ed39d591/Property_1_Happy.png',
    Energized:
      'https://cdn.alpineiq.com/media/1/7e55be5e-7c69-4029-8e20-53ae441b2523/Property_1_Energized.png',
    Creative: 'https://cdn.alpineiq.com/media/1/a709cf29-e4c7-44fd-8d14-fe9595681f58/Property_1_Creative.png',
    Stimulated:
      'https://cdn.alpineiq.com/media/1/a0f7cbcf-462a-4102-8ad5-37d340234efd/Property_1_Inspired.png',
    Relaxed: 'https://cdn.alpineiq.com/media/1/a18446bb-c241-49e9-bef2-42c8f5bc4031/Property_1_Relaxed.png',
    Sedated: 'https://cdn.alpineiq.com/media/1/93f06c01-6824-475a-a792-cda0dbd1569a/Property_1_sedated.png',
    Sleepy: 'https://cdn.alpineiq.com/media/1/56be8ade-d7f1-46f7-9390-ea50b0199a9a/Property_1_Sleepy.png',
    Uplifted: 'https://cdn.alpineiq.com/media/1/ad1c9a2e-8a5b-4a2e-b57d-535716c5439b/Property_1_uplifted.png',
  },
  '8 Bit': {
    Calm: '',
    Creative: '',
    Focused: '',
    Relaxed: '',
    Energized: '',
    Euphoric: '',
    Stimulated: '',
    Sedated: '',
    Sleepy: '',
    Uplifted: '',
  },
  Terpli: {
    Calm: '',
    Creative: '',
    Focused: '',
    Relaxed: '',
    Energized: '',
    Euphoric: '',
    Stimulated: '',
    Sedated: '',
    Sleepy: '',
    Uplifted: '',
  },
}

export const DEFAULT_EXPERIENCES_IMAGES_BY_PRESET: Record<
  IconPreset,
  Record<RecFlowExperience | ReviewFlowExperience, string>
> = {
  Classic: {
    Music: '',
    Stoned: '',
    Gaming: '',
    Morning: '',
    Exercise: '',
    Creativity: '',
    Sleeping: '',
    Socializing: '',
    Romancing: '',
    Focus: '',
    'Mood Boost': '',
    'Pain Relief': '',
    Anxious: '',
    // Hungry: '',
    // Giggly: '',
    // Paranoid: '',
    // Relief: '',
  },
  Smooth: {
    Music: 'https://cdn.alpineiq.com/media/1/361aed40-f79f-400f-a79d-8e181b454d6d/music.png',
    Stoned: 'https://cdn.alpineiq.com/media/1/fb2358d0-5a85-41ee-8da3-2f1fca9e3c51/stoned.png',
    Gaming: 'https://cdn.alpineiq.com/media/1/4692e208-749f-4b36-97f6-24abeed6a9a2/game.png',
    Morning: 'https://cdn.alpineiq.com/media/1/b4a252a5-46c6-4390-aa70-6f01135347d3/morn.png',
    Exercise: 'https://cdn.alpineiq.com/media/1/ad6769da-d2fb-4680-8bdc-4953a6f2c93b/exercise.png',
    Creativity: 'https://cdn.alpineiq.com/media/1/53232ef0-d347-45c7-ac0e-e5da093375a1/light.png',
    Sleeping: 'https://cdn.alpineiq.com/media/1/56be8ade-d7f1-46f7-9390-ea50b0199a9a/Property_1_Sleepy.png',
    Socializing: 'https://cdn.alpineiq.com/media/1/e5eabf84-0889-471a-8717-a58cad9820b9/social.png',
    Romancing: 'https://cdn.alpineiq.com/media/1/517b89f9-93e3-4fb2-9d6b-62ac80eeda88/romance.png',
    Focus: 'https://cdn.alpineiq.com/media/1/b96480fe-3781-4f68-b9f9-c7f7c4aeda56/Property_1_Focused.png',
    'Mood Boost':
      'https://cdn.alpineiq.com/media/1/ad1c9a2e-8a5b-4a2e-b57d-535716c5439b/Property_1_uplifted.png',
    'Pain Relief':
      'https://cdn.alpineiq.com/media/1/8d3a29b8-e550-41e5-beb3-a2c881f61529/Property_1_Medicinal.png',
    Anxious: 'https://cdn.alpineiq.com/media/1/5aa91525-5c72-4566-a646-ae2c4511aec0/Property_1_Anxiety.png',
    // Hungry: 'https://cdn.alpineiq.com/media/1/24abf7d9-81f7-40ad-892f-1e89d013c5a0/Property_1_hungryEmoji.png',
    // Giggly: 'https://cdn.alpineiq.com/media/1/c4d26aee-3ecd-4ecb-8d1a-f29050d5f555/Property_1_giggly.png',
    // Paranoid: 'https://cdn.alpineiq.com/media/1/1879f53d-5602-47a9-8462-138df595ffe9/Property_1_paranoid.png',
    // Relief: 'https://cdn.alpineiq.com/media/1/31008e23-0c08-45cc-b6ce-352f9e04b640/Property_1_pain_relief.png',
  },
  '8 Bit': {
    Music: '',
    Stoned: '',
    Gaming: '',
    Morning: '',
    Exercise: '',
    Creativity: '',
    Sleeping: '',
    Socializing: '',
    Romancing: '',
    Focus: '',
    'Mood Boost': '',
    'Pain Relief': '',
    Anxious: '',
    // Hungry: '',
    // Giggly: '',
    // Paranoid: '',
    // Relief: '',
  },
  Terpli: {
    Music: '',
    Stoned: '',
    Gaming: '',
    Morning: '',
    Exercise: '',
    Creativity: '',
    Sleeping: '',
    Socializing: '',
    Romancing: '',
    Focus: '',
    'Mood Boost': '',
    'Pain Relief': '',
    Anxious: '',
    // Hungry: '',
    // Giggly: '',
    // Giggly: '',
    // Paranoid: '',
    // Relief: '',
  },
}

export const DEFAULT_CATEGORIES_IMAGES: Record<Category, string> = {
  Flower: 'https://cdn.alpineiq.com/media/1/82a0838c-a410-49dd-abd4-3d479b2850da/Property_1_flower.png',
  Preroll: 'https://cdn.alpineiq.com/media/1/e7e9a6c6-9a04-4fea-a619-ec541ba5c2e6/Property_1_preroll.png',
  'Concentrates & Extracts':
    'https://cdn.alpineiq.com/media/1/daebfdac-f393-4558-883b-ac33ace1e78c/Property_1_concentrates.png',
  'Vape Cartridge':
    'https://cdn.alpineiq.com/media/1/0aa33a05-9c58-4919-984d-c4986d38e509/Property_1_vapes.png',
  Edible: 'https://cdn.alpineiq.com/media/1/be0ae517-c523-4c9c-b7a2-63c32b070400/Property_1_edibles-gummy.png',
}

export const DEFAULT_SUB_CATEGORIES_IMAGES: Record<EdibleSubCategory, string> = {
  chocolates: 'https://cdn.alpineiq.com/media/1/efd10a72-bb2f-4410-a0f6-463d447f4a78/Property_1_edibles.png',
  drinks: 'https://cdn.alpineiq.com/media/1/d7f04aa5-6d49-4115-9f9c-2753c5eefb79/Property_1_beverage.png',
  gummies: 'https://cdn.alpineiq.com/media/1/71b3f64c-8a93-4dc2-bfff-a703ed344f58/Property_1_merch.png',
  tinctures: 'https://cdn.alpineiq.com/media/1/9d874ecb-44af-4fa8-89b2-d71f2fbbef32/Property_1_tincturespng',
  tablets: 'https://cdn.alpineiq.com/media/1/eec0079e-917b-4da3-9b27-c865d4ca7bc1/Property_1_tablets.png',
  snacks: 'https://cdn.alpineiq.com/media/1/08adab75-dfb6-4405-bd35-356d5d5e1826/Property_1_Mixed.png',
  other: 'https://cdn.alpineiq.com/media/1/a860d76c-bf6d-4367-9d60-d509374c0e4f/Property_1_offer.png',
}

export const DEFAULT_TERPENES_IMAGES: Record<RecFlowTerpene, string> = {
  Caryophyllene:
    'https://cdn.alpineiq.com/media/1/ff94365d-08ce-4d43-959e-511d82a7b955/Property_1_Beta_Caryophyllene.png',
  Pinene: 'https://cdn.alpineiq.com/media/1/ab49ec64-66bd-49c7-8af6-7cf76198d08f/Property_1_Beta_Pinene.png',
  Linalool: 'https://cdn.alpineiq.com/media/1/fc1b80c3-62c4-4ea5-9f28-4e886569961c/Property_1_Linalool.png',
  Myrcene: 'https://cdn.alpineiq.com/media/1/be513608-a429-4929-8943-5e60f1a4a909/Property_1_Beta_Myrcene.png',
  Limonene: 'https://cdn.alpineiq.com/media/1/65910a32-c75a-4876-90a8-542a3368b79a/Property_1_Limolene.png',
  Terpinolene:
    'https://cdn.alpineiq.com/media/1/10082dd6-9888-494a-9efe-e1232bd07e42/Property_1_Terpinolene.png',
}

export const DEFAULT_SCENTS_IMAGES: Record<RecFlowScent, string> = {
  Hoppy: 'https://cdn.alpineiq.com/media/1/be513608-a429-4929-8943-5e60f1a4a909/Property_1_Beta_Myrcene.png',
  Citrusy: 'https://cdn.alpineiq.com/media/1/65910a32-c75a-4876-90a8-542a3368b79a/Property_1_Limolene.png',
  Spicy:
    'https://cdn.alpineiq.com/media/1/ff94365d-08ce-4d43-959e-511d82a7b955/Property_1_Beta_Caryophyllene.png',
  Floral: 'https://cdn.alpineiq.com/media/1/fc1b80c3-62c4-4ea5-9f28-4e886569961c/Property_1_Linalool.png',
  Earthy: 'https://cdn.alpineiq.com/media/1/ab49ec64-66bd-49c7-8af6-7cf76198d08f/Property_1_Beta_Pinene.png',
  Fruity: 'https://cdn.alpineiq.com/media/1/10082dd6-9888-494a-9efe-e1232bd07e42/Property_1_Terpinolene.png',
}
